import { Button } from "@/components/ui";
import {
  DistributionAction,
  useAvailableActions,
} from "@/network/useAvailableActions";
import { useStartForcedLiveChat } from "@/network/useStartForcedLiveChat";
import { useParams, useSearch } from "@tanstack/react-router";

export const ForceStartLiveChat = () => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const { encounterId } = useSearch({ from: "/patient/$patientId" });
  const { mutate: startForcedLiveChat, isPending } = useStartForcedLiveChat();

  const { data: actions } = useAvailableActions({
    patientId,
    encounterId: encounterId as string | undefined,
  });

  if (encounterId) {
    return null;
  }

  if (!actions?.[DistributionAction.FORCE_START_LIVE_CHAT]?.allowed) {
    return null;
  }

  return (
    <Button
      variant="primary"
      size="xs"
      onClick={() => {
        startForcedLiveChat();
      }}
      isLoading={isPending}
    >
      Start Live Chat
    </Button>
  );
};
